import Swiper, { Pagination } from 'swiper';
Swiper.use([Pagination]);

/**
 * STANDALONE CTASLIDER MODULE
 */
export namespace CTASlider {
	let SetupSlider = () => {
		let ctaSliders = document.querySelectorAll('.js-cta-slider');

		/**
		 * Find all of our sliders on the page and initialize swiper for each
		 */
		ctaSliders.forEach((slider, index) => {
			let parent = slider.closest('.cta-slider__wrapper');
			let pagination = parent.querySelector('.swiper-pagination');
			pagination.classList.add(`swiper-pagination--${index}`);
			parent.classList.add(`cta-slider__wrapper--${index}`);
			slider.classList.add('cta-slider--' + index);
			let fpSliderList = [];

			let fpSlider = new Swiper('.cta-slider--' + index, {
				slidesPerView: 1,
				speed: 400,
				spaceBetween: 0,
				centeredSlides: true,
				loop: false,
				simulateTouch: true,

				pagination: {
					el: `.swiper-pagination--${index}`,
					clickable: true
				},
			});

			fpSliderList.push(fpSlider);
			fpSlider.init();
		});
	}
	export const init = () => {
		SetupSlider();
	}
}


/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', CTASlider.init);
} else {  // `DOMContentLoaded` has already fired
	CTASlider.init();
}
